// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b68d89f1","455":"e1364480"}[chunkId] + ".chunk.js";
};